var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn btn-sm btn-info mx-1",attrs:{"to":_vm.to}},[_vm._v(" Certificado ")])
}
var staticRenderFns = []

export { render, staticRenderFns }